import { ScatterPlotDataShape, ScatterPlotDataShapeSize } from 'ChartApp/ts/enums/scatter-plot-common.enum';
const SCATTER_PLOT_PLOT_OPTIONS_DEFAULT = {
    color: '',
    shape: ScatterPlotDataShape.circle,
    display_x_y_data: false,
    display_currency_code: false,
    include_in_legend: true,
    display_dates: false,
    display_name: false,
    display_ticker: false,
    size: ScatterPlotDataShapeSize.medium,
    include_through_line: false,
};
// Dropdown Config Defaults
const SCATTER_PLOT_BOOLEAN_OPTIONS_DEFAULT = [
    { label: 'Show X/Y Data', value: 'display_x_y_data', checked: false },
    { label: 'Show Ticker', value: 'display_ticker', checked: false },
    { label: 'Show Name', value: 'display_name', checked: false },
    { label: 'Show Date', value: 'display_dates', checked: false },
    { label: 'Show Currency Code', value: 'display_currency_code', checked: false },
    { label: 'Include In Legend', value: 'include_in_legend', checked: true },
];
const SCATTER_PLOT_SHAPE_OPTIONS_DEFAULT = {
    list: [
        { label: 'Circle', value: 'circle' },
        { label: 'Triangle', value: 'triangle' },
        { label: 'Diamond', value: 'diamond' },
        { label: 'Cross', value: 'cross' },
    ],
};
const SCATTER_PLOT_SIZE_OPTIONS_DEFAULT = {
    list: [
        { label: 'Small', value: 'small' },
        { label: 'Medium', value: 'medium' },
        { label: 'Large', value: 'large' },
    ],
};
const SCATTER_PLOT_LABEL_PLACEMENT_OPTIONS_DEFAULT = {
    list: [
        { label: 'Default', value: '' },
        { label: 'Top Left', value: 'label_placement_top_left' },
        { label: 'Top Right', value: 'label_placement_top_right' },
        { label: 'Left', value: 'label_placement_left' },
        { label: 'Right', value: 'label_placement_right' },
        { label: 'Bottom Left', value: 'label_placement_bottom_left' },
        { label: 'Bottom Right', value: 'label_placement_bottom_right' },
    ],
};
export { SCATTER_PLOT_PLOT_OPTIONS_DEFAULT, 
// Dropdown Config Defaults
SCATTER_PLOT_BOOLEAN_OPTIONS_DEFAULT, SCATTER_PLOT_LABEL_PLACEMENT_OPTIONS_DEFAULT, SCATTER_PLOT_SHAPE_OPTIONS_DEFAULT, SCATTER_PLOT_SIZE_OPTIONS_DEFAULT, };
